module.exports = __webpack_public_path__ + "edc578bce20fb1b6e619b5d099d85c9b.pdf";